import React from 'react';
import Avatar, { initialsOf } from 'shared/components/ui/Avatar';

/**
 * Renders annotation body using the stored mentions array — not by extracting
 * @handles from the text on each paint.
 */
export default function AnnotationBody({ body, mentions = [], className = '' }) {
  const text = body || '';
  if (!mentions.length) {
    return (
      <p className={`whitespace-pre-wrap break-words text-[12px] leading-5 text-[color:var(--text-primary)] ${className}`}>
        {text}
      </p>
    );
  }

  const tokens = mentions
    .map((m) => `@${m.displayName}`)
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);

  const parts = [];
  let remaining = text;
  let key = 0;
  while (remaining.length) {
    let earliest = -1;
    let matched = null;
    tokens.forEach((token) => {
      const idx = remaining.indexOf(token);
      if (idx !== -1 && (earliest === -1 || idx < earliest)) {
        earliest = idx;
        matched = token;
      }
    });
    if (earliest === -1) {
      parts.push(<span key={`t-${key++}`}>{remaining}</span>);
      break;
    }
    if (earliest > 0) {
      parts.push(<span key={`t-${key++}`}>{remaining.slice(0, earliest)}</span>);
    }
    parts.push(
      <span
        key={`m-${key++}`}
        className="rounded px-0.5 font-medium text-[color:var(--trodo-primary)]"
      >
        {matched}
      </span>,
    );
    remaining = remaining.slice(earliest + matched.length);
  }

  return (
    <p className={`whitespace-pre-wrap break-words text-[12px] leading-5 text-[color:var(--text-primary)] ${className}`}>
      {parts}
    </p>
  );
}

export const initials = initialsOf;

/**
 * A comment's author, drawn as their picture when they have one.
 *
 * This used to be a hand-rolled initials bubble. It is the shared Avatar now,
 * so a comment shows the same face as the account menu and the members list —
 * the picture people actually recognise each other by.
 */
export function AnnotationAvatar({ name, src, size = 24 }) {
  return <Avatar name={name} src={src} size={size} />;
}
